/**
 * Downshift Scanner Stats - 3 category tiles
 */
import React from 'react';
import { Box, Typography, alpha, Skeleton } from '@mui/material';
import { TrendingDown, TrendingUp, SwapHoriz } from '@mui/icons-material';

const cats = [
  { key: 'distribution', label: 'Phân Phối', sub: 'Vùng đỉnh · SELL/TRIM', color: '#dc2626', Icon: TrendingDown },
  { key: 'accumulation', label: 'Tích Lũy', sub: 'Vùng đáy · BUY', color: '#16a34a', Icon: TrendingUp },
  { key: 'transition', label: 'Chuyển Giao', sub: 'Vùng giữa · WATCH', color: '#ca8a04', Icon: SwapHoriz },
];

const StatsCards = ({ distributionCount, accumulationCount, transitionCount, loading, onSelect }) => {
  const counts = [distributionCount, accumulationCount, transitionCount];
  const total = counts.reduce((s, c) => s + c, 0);

  if (loading) {
    return (
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1.5, mb: 2 }}>
        {[0, 1, 2].map(i => (
          <Skeleton key={i} variant="rounded" height={72} sx={{ borderRadius: 2 }} />
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1.5, mb: 2 }}>
      {cats.map((cat, idx) => {
        const count = counts[idx];
        const pct = total > 0 ? ((count / total) * 100).toFixed(0) : 0;
        return (
          <Box
            key={cat.key}
            onClick={() => onSelect?.(idx)}
            sx={{
              position: 'relative', overflow: 'hidden',
              borderRadius: 2, border: `1px solid ${alpha(cat.color, 0.15)}`,
              bgcolor: '#fff', p: '12px 14px',
              cursor: onSelect ? 'pointer' : 'default',
              transition: 'all 0.2s',
              '&:hover': {
                borderColor: alpha(cat.color, 0.35),
                boxShadow: `0 2px 12px ${alpha(cat.color, 0.1)}`,
                transform: 'translateY(-1px)',
              },
            }}
          >
            {/* Accent glow */}
            <Box sx={{
              position: 'absolute', top: 0, right: 0, width: 56, height: 56,
              background: `radial-gradient(circle at top right, ${alpha(cat.color, 0.06)} 0%, transparent 70%)`,
            }} />
            <Box sx={{ position: 'relative', display: 'flex', alignItems: 'flex-start', gap: 1.2 }}>
              <Box sx={{
                width: 34, height: 34, borderRadius: 1.5, flexShrink: 0,
                background: `linear-gradient(135deg, ${cat.color} 0%, ${alpha(cat.color, 0.7)} 100%)`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: `0 2px 6px ${alpha(cat.color, 0.3)}`,
              }}>
                <cat.Icon sx={{ fontSize: 18, color: '#fff' }} />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: '0.58rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#94a3b8', lineHeight: 1, mb: 0.4 }}>
                  {cat.label}
                </Typography>
                <Typography sx={{ fontSize: '1.5rem', fontWeight: 900, color: cat.color, lineHeight: 1, fontFamily: 'monospace' }}>
                  {count}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.4 }}>
                  <Typography sx={{ fontSize: '0.58rem', color: '#94a3b8', lineHeight: 1 }}>
                    {cat.sub}
                  </Typography>
                  {total > 0 && (
                    <Typography sx={{ fontSize: '0.58rem', fontWeight: 700, color: alpha(cat.color, 0.7), fontFamily: 'monospace' }}>
                      {pct}%
                    </Typography>
                  )}
                </Box>
                {/* Mini progress */}
                {total > 0 && (
                  <Box sx={{ mt: 0.5, height: 3, bgcolor: '#f1f5f9', borderRadius: 2, overflow: 'hidden' }}>
                    <Box sx={{ height: '100%', width: `${pct}%`, bgcolor: cat.color, borderRadius: 2, transition: 'width 0.4s ease' }} />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default StatsCards;
